
export const identificator = (state = '', action) => { 
    switch (action.type) {
        case 'IDENTIFICATOR_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const visitedStep = (state = [], action) => { 
    switch (action.type) {
        case 'VISITED_STEP_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const repurchase = (state = '0.00', action) => { 
    switch (action.type) {
        case 'REPURCHASE_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const initialCharge = (state = '0 zł', action) => { 
    switch (action.type) {
        case 'INITIAL_CHARGE_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const chargePrice = (state = [], action) => { 
    switch (action.type) {
        case 'CHARGE_PRICE_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const leasingTime = (state = [], action) => { 
    switch (action.type) {
        case 'LEASING_TIME_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const productPrice = (state = '0 zł', action) => { 
    switch (action.type) {
        case 'PRODUCT_PRICE_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const productPriceEnd = (state = [], action) => { 
    switch (action.type) {
        case 'PRODUCT_PRICE_END_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const tax = (state = '0 zł', action) => { 
    switch (action.type) {
        case 'TAX_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const selectedLease = (state = [], action) => { 
    switch (action.type) {
        case 'SELECTED_LEASE_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const modernLease = (state = [], action) => { 
    switch (action.type) {
        case 'MODERN_LEASE_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const traditionalLease = (state = [], action) => { 
    switch (action.type) {
        case 'TRADITIONAL_LEASE_CHANGE':
            return action.value;      
        default:
            return state
    }
}


export const minMonth = (state = '18', action) => { 
    switch (action.type) {
        case 'MIN_MONTH_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const maxMonth = (state = '48', action) => { 
    switch (action.type) {
        case 'MAX_MONTH_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const minInitial = (state = '0', action) => { 
    switch (action.type) {
        case 'MIN_INITIAL_CHANGE':
            return action.value;      
        default:
            return state
    }
}
export const maxInitial = (state = '30', action) => { 
    switch (action.type) {
        case 'MAX_INITIAL_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const allowForm = (state = true, action) => { 
    switch (action.type) {
        case 'ALLOW_FORM_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const finalRate = (state = [], action) => { 
    switch (action.type) {
        case 'FINAL_RATE_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const rateFrequency = (state = [], action) => { 
    switch (action.type) {
        case 'RATE_FREQUENCY_CHANGE':
            return action.value;      
        default:
            return state
    }
}
export const provider = (state = true, action) => { 
    switch (action.type) {
        case 'PROVIDER_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const providerName = (state = '', action) => { 
    switch (action.type) {
        case 'PROVIDER_NAME_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const providerPostal = (state = '', action) => { 
    switch (action.type) {
        case 'PROVIDER_POSTAL_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const providerNip = (state = [], action) => { 
    switch (action.type) {
        case 'PROVIDER_NIP_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const legalForm = (state = true, action) => { 
    switch (action.type) {
        case 'LEGAL_FORM_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const callNumber = (state = false, action) => { 
    switch (action.type) {
        case 'CALL_NUMBER_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const callEmail = (state = false, action) => { 
    switch (action.type) {
        case 'CALL_EMAIL_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const isShop = (state = false, action) => { 
    switch (action.type) {
        case 'IS_SHOP_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const openedMail = (state = false, action) => { 
    switch (action.type) {
        case 'OPENED_MAIL_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const rate = (state = [], action) => { 
    switch (action.type) {
        case 'RATE_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const urlFormFinish = (state = '', action) => { 
    switch (action.type) {
        case 'URL_FORM_FINISH_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const urlFormFinishExternal = (state = '', action) => { 
    switch (action.type) {
        case 'URL_FORM_FINISH_EXTERNAL_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const endPage = (state = false, action) => { 
    switch (action.type) {
        case 'END_PAGE_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const courier = (state = true, action) => { 
    switch (action.type) {
        case 'COURIER_CHANGE':
            return action.value;      
        default:
            return state
    }
}
export const fvFile = (state = [], action) => { 
    switch (action.type) {
        case 'FV_FILE_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const showEsign = (state = false, action) => { 
    switch (action.type) {
        case 'SHOW_ESIGN_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const showEsignMaxPrice = (state = 0, action) => { 
    switch (action.type) {
        case 'SHOW_ESIGN_MAX_PRICE_CHANGE':
            return action.value;      
        default:
            return state
    }
}



export const showTax = (state = false, action) => { 
    switch (action.type) {
        case 'SHOW_TAX_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const minThreshold = (state = false, action) => { 
    switch (action.type) {
        case 'MIN_THRESHOLD_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const maxThreshold = (state = false, action) => { 
    switch (action.type) {
        case 'MAX_THRESHOLD_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const errorFvUpload = (state = false, action) => { 
    switch (action.type) {
        case 'ERROR_FV_UPLOAD_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const errorAddProductFV = (state = false, action) => { 
    switch (action.type) {
        case 'ERROR_ADD_PRODUCT_FV_CHANGE':
            return action.value;      
        default:
            return state
    }
}


export const fromDbLoaded = (state = false, action) => { 
    switch (action.type) {
        case 'FROM_DB_LOADED_CHANGE':
            return action.value;      
        default:
            return state
    }
}

export const disableUpload = (state = false, action) => { 
    switch (action.type) {
        case 'DISABLE_UPLOAD':
            return action.value;      
        default:
            return state
    }
}

export const uploadValidate = (state = false, action) => { 
    switch (action.type) {
        case 'UPLOAD_VALIDATE':
            return action.value;      
        default:
            return state
    }
}

export const successFv = (state = false, action) => { 
    switch (action.type) {
        case 'SUCCESS_FV':
            return action.value;      
        default:
            return state
    }
}

export const partnerPromotionText = (state = "", action) => { 
    switch (action.type) {
        case 'PARTNER_PROMOTION_TEXT_CHANGE':
            return action.value;      
        default:
            return state
    }
}